var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.52 71.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;stroke-width:0.5px;}.cls-2{fill:#d68828;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2207",
    "data-name": "Group 2207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-1",
    d: "M35.76,61.29a2.43,2.43,0,0,1-1.69-.69c-3-3-14.54-20.53-14.54-30.62,0-10.47,5.76-16.23,16.23-16.23S52,19.51,52,30c0,10.1-11.54,27.64-14.55,30.62A2.38,2.38,0,0,1,35.76,61.29Zm0-45.27c-6.37,0-13.95,2.42-13.95,14,0,8.91,10.52,25.68,13.87,29a.12.12,0,0,0,.16,0c3.35-3.33,13.87-20.1,13.87-29,0-11.53-7.59-13.93-14-13.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    className: "cls-2",
    cx: 35.76,
    cy: 31.08,
    r: 6.46
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.cf30ff6139df771abf96ddea4e6c7da1.svg";
export { ForwardRef as ReactComponent };